module.exports = kolibriCoreAppGlobal.coreVue.components.PrivacyLinkAndModal;